import { StackLayout, Image, Box } from "@leagueplatform/genesis-core";
import OnboardingImage from "assets/onboarding-image.svg";

export const PreLoginPageBackgroundImage = ({
  isMobile,
}: {
  isMobile: boolean;
}) =>
  isMobile ? (
    <StackLayout
      css={{
        height: "320px",
        width: "100vw",
        alignItems: "center",
        justifyContent: "flex-end",
        marginBlockStart: "$five",
      }}
    >
      <Image src={OnboardingImage} alt="" height="241px" width="193px" />
    </StackLayout>
  ) : (
    <Box
      css={{
        flexBasis: "45%",
        height: "100vh",
      }}
    >
      <Box
        css={{
          clipPath: "ellipse(100% 85% at left)",
          backgroundColor: "$surfaceBackgroundTertiary",
          height: "100%",
          display: "flex",
          alignItems: "center",
          paddingInline: "$five",
        }}
      >
        <Image src={OnboardingImage} alt="" height={550} width={440} />
      </Box>
    </Box>
  );
